import styles from './AccountHome.module.css';
import '../../resources/css/admin_style.css';
import React, { useEffect, useRef, useState, useContext } from "react";
import { AuthContext } from "../../utils/contextapi/AuthProvider";
import Loading from "../../utils/loading/Loading";
import { IAM_PATH, IAM_SERVER_DASHBOARD, OAUTH, USER_SERVER_DASHBOARD_CHART, USER_SERVER_IDENTITY } from "../../utils/Config";
import axios from "../../utils/api/axios";
import AccountInfoPanel from './commponet/AccountInfoPanel';
import ContactInfoPanel from './commponet/ContactInfoPanel';
import AddressInfoPanel from './commponet/AddressInfoPanel';
import LinkedAccountsPanel from './commponet/LinkedAccountsPanel';
import ProfilesPanel from './commponet/ProfilesPanel';
import DeleteAccountsPanel from './commponet/DeleteAccountsPanel';
import { setCookie, getCookie, deleteCookie } from '../../utils/cookies/cookies.js';


/**
 * 사용자 정보 화면
 * @param callback
 * @param delay
 */

function AccountHome({ setMovePage }) {
    const [userData, setUserData] = useState(null);

    const {
        saveUser,
        saveRole,
        role,
        doLogout
    } = useContext(AuthContext);

    // 최초 로딩 여부
    const isFirstLoadRef = useRef(true);

    const [isSysIam, setIsSysIam] = useState(false);

    // 사용자 정보 로딩 함수
    const loadUser = async (isUpdate = false) => {
        if (isUpdate) {
            axios.get(OAUTH + "/userinfo").then((res) => {
                const data = res.data;
                const roles = Array.isArray(data.roles) ? data.roles.filter(Boolean) : ["USER"];

                saveUser(data);
                saveRole(roles);
            });
        } else {
        }
        const stored = getCookie("user");
        if (stored) setUserData(JSON.parse(stored));

    };

    useEffect(() => {
        if (isFirstLoadRef.current) {
            loadUser(false); // 최초 로딩
            isFirstLoadRef.current = false;
        }
        if (role && Array.isArray(role)) {
            if (role.includes("SYS_ADMIN") && getCookie("user_id") === 'sysiam') {
                setIsSysIam(true);
            }
        }
    }, []);

    if (!userData) return <Loading />;

    return (
        <div className={styles.layoutWrapper}>
            <h3>계정 관리</h3>  

            <div className={styles.contentsWrapper}>
                <div className={styles.accountContent}>
                    <div className={styles.infoCard}>
                        <AccountInfoPanel user={userData} onUserUpdate={() => loadUser(true)} />
                    </div>
                    <div className={styles.infoCard}>
                        <ContactInfoPanel user={userData} onUserUpdate={() => loadUser(true)} />
                    </div>
                    <div className={styles.infoCard}>
                        <AddressInfoPanel user={userData} onUserUpdate={() => loadUser(true)} />
                    </div>
                    <div className={styles.infoCard}>
                        <ProfilesPanel user={userData} onUserUpdate={() => loadUser(true)} />
                    </div>
                </div>
                <div className={styles.accountContent}> 
                    
                    <div className={styles.infoCard}>
                        <LinkedAccountsPanel user={userData} />
                    </div>
                    {!isSysIam &&
                        <div className={styles.infoCard}>
                            <DeleteAccountsPanel user={userData} onUserUpdate={() => loadUser(true)} doLogout={doLogout} />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default AccountHome;